"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpsNewPolicyRequestObjectDtoToJSON = exports.OpsNewPolicyRequestObjectDtoFromJSONTyped = exports.OpsNewPolicyRequestObjectDtoFromJSON = exports.instanceOfOpsNewPolicyRequestObjectDto = void 0;
var runtime_1 = require("../runtime");
var LMNTemplateEnum_1 = require("./LMNTemplateEnum");
var MissingCriticalInfo_1 = require("./MissingCriticalInfo");
var OpsPolicyTargetingDto_1 = require("./OpsPolicyTargetingDto");
/**
 * Check if a given object implements the OpsNewPolicyRequestObjectDto interface.
 */
function instanceOfOpsNewPolicyRequestObjectDto(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfOpsNewPolicyRequestObjectDto = instanceOfOpsNewPolicyRequestObjectDto;
function OpsNewPolicyRequestObjectDtoFromJSON(json) {
    return OpsNewPolicyRequestObjectDtoFromJSONTyped(json, false);
}
exports.OpsNewPolicyRequestObjectDtoFromJSON = OpsNewPolicyRequestObjectDtoFromJSON;
function OpsNewPolicyRequestObjectDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'syndrome': !(0, runtime_1.exists)(json, 'syndrome') ? undefined : json['syndrome'],
        'sourceUrl': !(0, runtime_1.exists)(json, 'sourceUrl') ? undefined : json['sourceUrl'],
        'sourceId': !(0, runtime_1.exists)(json, 'sourceId') ? undefined : json['sourceId'],
        'sourceDate': !(0, runtime_1.exists)(json, 'sourceDate') ? undefined : json['sourceDate'],
        'lmnTemplate': !(0, runtime_1.exists)(json, 'lmnTemplate') ? undefined : (0, LMNTemplateEnum_1.LMNTemplateEnumFromJSON)(json['lmnTemplate']),
        'citationName': !(0, runtime_1.exists)(json, 'citationName') ? undefined : json['citationName'],
        'citationFull': !(0, runtime_1.exists)(json, 'citationFull') ? undefined : json['citationFull'],
        'targeting': !(0, runtime_1.exists)(json, 'targeting') ? undefined : (json['targeting'].map(OpsPolicyTargetingDto_1.OpsPolicyTargetingDtoFromJSON)),
        'criticalInfo': !(0, runtime_1.exists)(json, 'criticalInfo') ? undefined : (json['criticalInfo'].map(MissingCriticalInfo_1.MissingCriticalInfoFromJSON)),
        'explanationDetails': !(0, runtime_1.exists)(json, 'explanationDetails') ? undefined : json['explanationDetails'],
    };
}
exports.OpsNewPolicyRequestObjectDtoFromJSONTyped = OpsNewPolicyRequestObjectDtoFromJSONTyped;
function OpsNewPolicyRequestObjectDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'syndrome': value.syndrome,
        'sourceUrl': value.sourceUrl,
        'sourceId': value.sourceId,
        'sourceDate': value.sourceDate,
        'lmnTemplate': (0, LMNTemplateEnum_1.LMNTemplateEnumToJSON)(value.lmnTemplate),
        'citationName': value.citationName,
        'citationFull': value.citationFull,
        'targeting': value.targeting === undefined ? undefined : (value.targeting.map(OpsPolicyTargetingDto_1.OpsPolicyTargetingDtoToJSON)),
        'criticalInfo': value.criticalInfo === undefined ? undefined : (value.criticalInfo.map(MissingCriticalInfo_1.MissingCriticalInfoToJSON)),
        'explanationDetails': value.explanationDetails,
    };
}
exports.OpsNewPolicyRequestObjectDtoToJSON = OpsNewPolicyRequestObjectDtoToJSON;
